export abstract class ObjectBase {
    constructor() {}
    abstract copy(): any;
    abstract copyFrom( object: any, objectTmp: any ): void;
}